import { Alert, Button } from "@mui/material";
import Badge from "../../components/ui/badge/Badge";
import type { OnboardingDetailItem } from "../../types/onboarding";
import { partyLabel } from "./labels";
import { toWaitedLabel, withoutBrand } from "./checklistRows";

interface Props {
  items: OnboardingDetailItem[];
  saving: boolean;
  error: string | null;
  onOpen: (item: OnboardingDetailItem) => void;
  onChase: (item: OnboardingDetailItem) => void;
}

export default function ChaseNow({ items, saving, error, onOpen, onChase }: Props) {
  const overdue = items.filter((item) => item.overdue);
  if (!overdue.length) return null;
  return (
    <section aria-label="Chase now" className="overflow-hidden rounded-xl border border-error-200 bg-white dark:border-error-500/30 dark:bg-white/[0.03]">
      <div className="flex items-baseline gap-2 bg-error-25 px-4 py-2.5 dark:bg-error-500/10">
        <span className="text-sm font-semibold text-error-700 dark:text-error-400">Chase now</span>
        <span className="text-xs text-gray-500">Waiting past the chase time</span>
      </div>
      {error && <Alert severity="error" sx={{ borderRadius: 0 }}>{error}</Alert>}
      {overdue.map((item) => (
        <div key={item.itemId} className="flex flex-wrap items-center gap-x-3 gap-y-1 border-t border-gray-100 px-4 py-2 dark:border-gray-800">
          <button type="button" onClick={() => onOpen(item)} className="w-full min-w-0 cursor-pointer text-left text-sm text-gray-800 sm:w-auto sm:flex-1 dark:text-white/90">
            {withoutBrand(item)}
            {item.brandName && <span className="text-gray-500"> · {item.brandName}</span>}
          </button>
          <Badge size="sm" color="light">{partyLabel(item)}</Badge>
          <span className="text-sm text-error-600">{toWaitedLabel(item)}</span>
          <Button size="small" variant="outlined" disabled={saving} onClick={() => onChase(item)}>Chased</Button>
        </div>
      ))}
    </section>
  );
}
